import React, { useState } from 'react'
import ModalVideo from 'react-modal-video'

import videobg from '../../../assets/img/banner/09.jpg'
// import line1 from '../../../assets/img/lines/11.png'
// import line2 from '../../../assets/img/lines/12.png'

function Video(props) {
    const [openVideo, setOpenVideo] = useState(false)

    const openVideoModal = () => {
        setOpenVideo(true)
    }

    return (
        <section className="video-section bg-img-c" style={{ backgroundImage: "url(" + videobg + ")" }}>
            <div className="container">
                <div className="row align-content-center justify-content-center">
                    <div className="col-lg-12">
                        <div className="video-cont text-center">
                            <div style={{ padding: "4em" }} />
                            <span onClick={openVideoModal} className="fadeInLeft" role="button"
                                data-wow-duration="1500ms" data-wow-delay="400ms">
                                {/* <i className="fas fa-play" /> */}
                            </span>

                            <h2 style={{ color: "white" }}>
                                Book your appointment with me today!
                            </h2>
                            <div>
                                <div class="calendly-inline-widget" style={{ minWidth: "320px", height: "680px" }} data-url="https://calendly.com/jwo"></div>
                            </div>
                            <div style={{ padding: "2em" }} />
                        </div>
                    </div>
                </div>
            </div>

            <ModalVideo channel="youtube" autoplay isOpen={openVideo} videoId="nvbdqnAjUwo" onClose={() => setOpenVideo(false)} />
        </section>
    );
}

export default Video;